import { Fragment, useContext } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import CustomizerContext from '../../../../_helper/Customizer';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { InteractionGroupApi } from '../../../../api';
import { toast } from 'react-toastify';
import CardRibbonWithForm from '../../../Common/Component/CardRibbonWithForm';
import { base_form_fields } from '../../../../Data/FormField/PublicData';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import { InteractionGroup } from '../../../../Constant';
import useAuth from '../../../../Hooks/useAuth';

const InteractionGroupCreate = () => {
  const history = useNavigate();
  const axiosPrivate = useAxiosPrivate()
  const { userOrganisationId } = useAuth();
  const { layoutURL } = useContext(CustomizerContext);
  const lists = `${process.env.PUBLIC_URL}/crm/settings/interaction-groups/${layoutURL}`;

  const { formState: { errors }, } = useForm();

  const addNewRecord = async (newRecord) => {
    if (newRecord === '') {
      errors.showMessages();
    }

    const newRecordTemp = {
      organisation_id : userOrganisationId,
      name: newRecord.name,
      description: newRecord.description,
      is_active: newRecord.is_active,
     };

    try {
      await axiosPrivate.post(InteractionGroupApi, newRecordTemp).then((resp) => {
        toast.success(`${resp.data.name} is successfully added.`)
        history(lists);
      });
    } catch (error) {
      if (error.response && error.response.status === 422) {
        toast.error('Validation Errors');
      } else if (error.response && error.response.status === 400) {
        toast.error(error.response.data.detail);
      }
      else {
        toast.error('Form submission error');
      }
      throw error;
    }
  };

  /*   const getUploadParams = ({ meta }) => {
      return {
        url: 'http://localhost:8001/public-data/upload',
      };
    };
  
    // called every time a file's `status` changes
    const handleChangeStatus = ({ meta, file }, status) => {}; */

  return (
    <Fragment>
      <Breadcrumbs parent="CRM" title="Interaction Group" mainTitle="Interaction Group" />
      <Container fluid={true}>
        <Row>
          <Col sm='10'>
            <CardRibbonWithForm formFields={base_form_fields(`${InteractionGroup}`)} onSubmit={addNewRecord} ribbonUrl={lists} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default InteractionGroupCreate;